import { useNavigate } from 'react-router-dom';
import { Card, CardTitle } from '@/components/ui/card';
import { Badge, type BadgeProps } from '@/components/ui/badge';

interface AttentionRow {
  badge: string;
  variant: NonNullable<BadgeProps['variant']>;
  text: string;
  action: string;
  to: string;
}

const ROWS: AttentionRow[] = [
  {
    badge: 'SIN RECURSO',
    variant: 'bad',
    text: 'AV-025 · inconsciente, vía pública',
    action: 'escalar a SUMMA ›',
    to: '/avisos',
  },
  {
    badge: 'SIN ASIGNAR',
    variant: 'warn',
    text: 'AV-019 · caída mayor (vencida)',
    action: 'asignar ›',
    to: '/avisos',
  },
  {
    badge: 'FLOTA',
    variant: 'flota',
    text: 'A-001 · estroboscópicos pendientes',
    action: 'ver ›',
    to: '/vehiculos',
  },
];

export function AttentionCard() {
  const navigate = useNavigate();
  const rows = ROWS;

  return (
    <Card className="p-[16px]">
      <CardTitle className="mb-[12px]">Necesita tu atención</CardTitle>
      {rows.length === 0 ? (
        <div className="grid min-h-[120px] place-items-center font-mono text-[10px] uppercase tracking-[.5px] text-s-dim">
          Sin elementos pendientes
        </div>
      ) : (
        rows.map((row, i) => (
          <button
            type="button"
            key={row.badge + row.text}
            onClick={() => navigate(row.to)}
            className="flex w-full cursor-pointer items-center gap-[10px] px-[2px] py-[11px] text-left text-[12.5px] text-s-text"
            style={
              i < rows.length - 1
                ? { borderBottom: '1px solid var(--s-line)' }
                : undefined
            }
          >
            <Badge variant={row.variant}>{row.badge}</Badge>
            <span>{row.text}</span>
            <span className="ml-auto font-mono text-[10px] text-s-mid">
              {row.action}
            </span>
          </button>
        ))
      )}
    </Card>
  );
}
